import style from './P2PContactPageView.css';
import SearchBox from '../../shared/SearchBox/SearchBox';
import List from '../../shared/List/List';
import ListItem from '../../shared/List/ListItem';
import useTranslation from '../../../localization/i18n.context';
import AddIcon from '../../shared/Icons/AddIcon';
import P2PContactList from '../P2PContactList/P2PContactList';
import { useEffect, useState } from 'preact/hooks';
import NavigationUtils from '../../../utils/navigation.utils';

export default function P2PContactPageView({
  className = '',
  contacts = [],
  onGoToSettingsButtonClick,
  permissionGranted,
  cardUid,
}) {
  const [filtrableContacts, setFiltrableContacts] = useState(contacts);
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  function onSearchBoxChange(e) {
    setSearch(e.target.value.trim());
  }

  useEffect(() => {
    setFiltrableContacts(
      contacts.filter(contact =>
        contact.name.toLowerCase().includes(search.toLowerCase()),
      ),
    );
  }, [search]);

  return (
    <div className={`${className}`}>
      <SearchBox
        className={style.search}
        placeholder={t('Search')}
        value={search}
        onChange={onSearchBoxChange}
        onClear={() => setSearch('')}
        disabled={contacts.length === 0}
      />
      {search.length === 0 && (
        <List className={style.addPhone}>
          <ListItem
            icon={
              <div className={style.addIcon}>
                <AddIcon color={'white'} />
              </div>
            }
            title={t('Add phone number')}
            titleClassName={style.addButtonText}
            actionable={true}
            onClick={() =>
              NavigationUtils.navigate(
                NavigationUtils.Routes.P2P_MANUAL_PHONE_NUMBER.replace(
                  ':cardUidFrom',
                  cardUid,
                ),
                false,
              )
            }
          />
        </List>
      )}

      <P2PContactList
        className={style.contacts}
        contacts={filtrableContacts}
        search={search}
        onGoToSettingsButtonClick={onGoToSettingsButtonClick}
        permissionGranted={permissionGranted}
        cardUid={cardUid}
      />
    </div>
  );
}
